import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import ReactDOM from 'react-dom'

import _ from 'underscore';
import moment from 'moment'

import { acRundaSelectata } from '../actions/acRundaSelectata';
import { acBilet } from '../actions/acBilet';

class Mid1ConNrRunde extends React.Component {

    constructor() {
        super();
        this.state = {
            hover: false,
            active: false
        }
        // hoverOn: function(){
        //     this.setState({ hover: true });
        //   },
        //   hoverOff: function(){
        //     this.setState({ hover: false });
        //   },
    }
    hoverOn(a) {
        this.setState({ hover: true });
        let nextSib, prevSib, rounds, i
        // let prevPrevSib, nextNextSib
        rounds = document.getElementsByClassName("con-round");
        for (i = 0; i < rounds.length; i++) {

            if (rounds[i] === a.target && !rounds[i].className.includes('active')) {

                prevSib = rounds[i - 1];
                // prevPrevSib = rounds[i - 2];
                nextSib = rounds[i + 1];
                // nextNextSib = rounds[i + 2];

                if (nextSib) {
                    nextSib.classList.add("next")
                    // if (nextNextSib) {
                    //     nextNextSib.classList.add("nextNext")
                    // }
                }

                if (prevSib) {
                    prevSib.classList.add("prev")
                    // if (prevPrevSib) {
                    //     prevPrevSib.classList.add("prevPrev")
                    // }
                }
            }
        }
    }
    hoverOff(a) {
        this.setState({ hover: false });
        // let nextSib, prevSib, rounds, i, j, prevPrevSib, nextNextSib, clase
        let rounds, i, j, clase
        rounds = document.getElementsByClassName("con-round");
        for (i = 0; i < rounds.length; i++) {
            // console.log('-->1', rounds[i]);
            // console.log('-->2', a.target);


            // if (rounds[i] === a.target) {
            //     prevSib = rounds[i - 1];
            //     prevPrevSib = rounds[i - 2];
            //     nextSib = rounds[i + 1];
            //     nextNextSib = rounds[i + 2];

            //     if (nextSib) {
            //         nextSib.classList.remove("next")
            //         // if (nextNextSib) {
            //         //     nextNextSib.classList.remove("nextNext")
            //         // }
            //     }

            //     if (prevSib) {
            //         prevSib.classList.remove("prev")
            //         // if (prevPrevSib) {
            //         //     prevPrevSib.classList.remove("prevPrev")
            //         // }
            //     }
            // }


            clase = rounds[i].className.split(' ')
            for (j = 0; j < clase.length; j++) {
                if (clase[j] === "prev") {
                    rounds[i].classList.remove("prev")
                }
                if (clase[j] === "prevPrev") {
                    rounds[i].classList.remove("prevPrev")
                }
                if (clase[j] === "next") {
                    rounds[i].classList.remove("next")
                }
                if (clase[j] === "nextNext") {
                    rounds[i].classList.remove("nextNext")
                }
            }
        }
    }
    componentDidMount() {
        var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
        if (findBilet && this.props.activeLot.name_lot === findBilet.numeLot) {
            if (findBilet.valid === true) {
                var rundaSelect = {
                    gameType: findBilet.gameType,
                    id: findBilet.idRunda,
                    round_unique: findBilet.roundUnique,
                    selectedLot: findBilet.numeLot,
                    timeStart: findBilet.timeStart
                }
                this.props.acRundaSelectata(rundaSelect)
            }
        } else if (this.props.index === 0) {
            this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type })
        }
    }
    selectRound() {
        this.props.acRundaSelectata({ ...this.props.rundaVal, gameType: this.props.activeLot.game_type });
        if (this.props.bilete !== null) {
            var findBilet = _.findWhere(this.props.bilete, { position: this.props.biletTab });
            var futureArr = []
            if(findBilet && findBilet.future && parseInt(findBilet.future) > 0) {
                var rundeArr = []
                for (let i = 0; i < this.props.runde.length; i++) {
                    rundeArr.push(this.props.runde[i].timeStart)
                }
                var rai = _.indexOf(rundeArr, this.props.rundaVal.timeStart);
                futureArr = rundeArr.slice(rai, rai + parseInt(findBilet.future) + 1)
            }
            if (findBilet && this.props.rundaVal.selectedLot === findBilet.numeLot) {
                this.props.acBilet([
                    'changeRound', 
                    { 
                        ...this.props.rundaVal, 
                        gameType: this.props.activeLot.game_type, 
                        position: this.props.biletTab,
                        futureArr: futureArr 
                    }
                ])
            }
        }
    }
    activeRound() {
        if (this.props.rundaSelectata.round_unique === this.props.rundaVal.round_unique) {
            return 'active'
        }
    }

    hoverClass() {
        if (this.state.hover === true) {
            return 'hover'
        }
    }
    render() {
        // console.log('conSizeChange', this.props.conSizeChange);
        if (this.props.rundaSelectata !== null) {
            return (
                <div
                    // onMouseEnter={this.hoverOn.bind(this)} onMouseLeave={this.hoverOff.bind(this)} id={this.hoverClass()}
                    onClick={this.selectRound.bind(this)} className={this.activeRound() + ' con-round'} >
                    <div className="draw">{this.props.multiLang.draw.txt}</div>
                    <div className="hour">{moment(this.props.rundaVal.timeStart).format('HH:mm')}</div>
                    <div className="date">{moment(this.props.rundaVal.timeStart).format('DD.MM')}</div>
                    <div className="commercial_id">{this.props.rundaVal.commercial_round_id ? 'ID:' + this.props.rundaVal.commercial_round_id : null}</div>
                </div>
            )

        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        activeLot: state.activeLot,
        rundaSelectata: state.rundaSelectata,
        biletTab: state.biletTab,
        bilete: state.bilete,
        conSizeChange: state.conSizeChange,
        multiLang: state.multiLang,
        runde: state.runde
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acRundaSelectata: acRundaSelectata,
        acBilet: acBilet
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(Mid1ConNrRunde);